<template>
  <div class="c-works">
    <div class="l-background">

      <div
        v-for="post in dataOutput"
        :key="post.id"
      >
        <div v-if="post.id == worksId">
          <Nav :title='`Works： ${post.title.rendered}`' />
          <div class="l-wapper">
            <div class="c-panel">
              <div class="c-works-detail__card">
                <img
                  v-if="post.acf.image"
                  class="c-works-detail__card-img"
                  :src="post.acf.image"
                  alt=""
                >
                <p
                  class="c-works-detail__card-text"
                  v-html="post.acf.text"
                >
                </p>
                <div class="c-works-detail">
                  <a
                    v-if="post.acf.link"
                    class="c-works-detail__card-link"
                    target="_blank"
                    :href="post.acf.link"
                  >Link : <span class="c-works-detail__card-linkurl">{{ post.acf.link }}</span>
                  </a>
                  <div>

                    <ul class="c-works__skills">
                      <li
                        class="c-works__skills-list"
                        v-if="post.acf.cat[0]"
                      >
                        {{ post.acf.cat[0] }}
                      </li>
                      <li
                        class="c-works__skills-list"
                        v-if="post.acf.cat[1]"
                      >
                        {{ post.acf.cat[1] }}
                      </li>
                      <li
                        class="c-works__skills-list"
                        v-if="post.acf.cat[2]"
                      >
                        {{ post.acf.cat[2] }}
                      </li>
                      <li
                        class="c-works__skills-list"
                        v-if="post.acf.cat[3]"
                      >
                        {{ post.acf.cat[3] }}
                      </li>
                      <li
                        class="c-works__skills-list"
                        v-if="post.acf.cat[4]"
                      >
                        {{ post.acf.cat[4] }}
                      </li>
                      <li
                        class="c-works__skills-list"
                        v-if="post.acf.cat[5]"
                      >
                        {{ post.acf.cat[5] }}
                      </li>
                      <li
                        class="c-works__skills-list"
                        v-if="post.acf.cat[6]"
                      >
                        {{ post.acf.cat[6] }}
                      </li>
                      <li
                        class="c-works__skills-list"
                        v-if="post.acf.cat[7]"
                      >
                        {{ post.acf.cat[7] }}
                      </li>
                      <li
                        class="c-works__skills-list"
                        v-if="post.acf.cat[8]"
                      >
                        {{ post.acf.cat[8] }}
                      </li>
                      <li
                        class="c-works__skills-list"
                        v-if="post.acf.cat[9]"
                      >
                        {{ post.acf.cat[9] }}
                      </li>
                    </ul>

                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "WorksDetail",
  props: {
    title: String
  },
  components: {
    Nav,
    Footer
  },
  computed: {
    dataOutput() {
      return this.$store.getters.getStateDataSet;
    },
    worksId() {
      return this.$route.params.id;
    }
  },
  created() {
    this.$store.dispatch("commitDataSet");
  }
};
</script>

<style lang="scss">
.c-works {
  position: relative;

  color: #666360;
  &-detail {
    &__card {
      box-shadow: inset 2px 2px 5px #babecc, inset -5px -5px 10px #fff;
      &-img {
        width: 100%;
        padding: 20px;
        @media only screen and (max-width: 768px) {
          padding: 10px;
        }
      }

      &-text {
        padding: 20px;
        @media only screen and (max-width: 768px) {
          padding: 10px;
        }
      }

      &-link {
        display: block;

        padding: 20px;

        @media only screen and (max-width: 768px) {
          padding: 10px;
        }
      }

      &-linkurl {
        text-decoration: underline;
      }
    }

    & .c-works__skills {
      padding: 0 12px 20px 2px;
    }
  }
}
</style>
